/** CRC Evans design-system tokens for weld dashboard charts. */
export const DASHBOARD_COLORS = {
  blue: '#00273F',
  red: '#EB1C37',
  readableRed: '#C4001F',
  green: '#1F9A3A',
  yellow: '#FFCA57',
  grey: '#969696',
  text: '#464646',
  border: '#E2E5EA',
  pass: '#1F9A3A',
  fail: '#EB1C37',
  other: '#969696',
  outlier: '#FFCA57',
  chartGrid: 'rgba(0,39,63,0.08)',
  /** Mid blue for histogram / count bars (readable on white). */
  chartBar: '#2E8AB8',
} as const;

export const cardClass =
  'rounded-2xl border border-[#E2E5EA] bg-white p-5 shadow-sm transition hover:shadow-md';

export const sectionTitleClass = 'font-heading text-sm font-semibold text-blueprint-blue';

export const sectionSubtitleClass = 'text-xs text-heritage-grey';
